import { render } from "./ListingSourceIcon.vue?vue&type=template&id=edfd4b46"
import script from "./ListingSourceIcon.vue?vue&type=script&lang=js"
export * from "./ListingSourceIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__